import { useSelector, useDispatch } from 'react-redux';
import { closeModal } from 'state/modal/modalSlice';
import { removeElement } from 'state/fence/fenceSlice';
import { getCurrentFenceGroup } from 'state/fence/fenceSelector';
import { editNewElementProps } from 'state/newElement/newElementSlice';
import { elementNames } from 'helpers/globals';
import { getItemById, getItemIndexById } from 'helpers/utils';
import ModalBase from 'components/common/ModalBase/ModalBase';
import ButtonBase from 'components/common/ButtonBase/ButtonBase';

const ModalRemoveElement = () => {
  const dispatch = useDispatch();
  const currentFenceGroup = useSelector(getCurrentFenceGroup);
  const modal = useSelector((state) => state.modal);
  const currentIndex = getItemIndexById(currentFenceGroup.elements, modal.props.id);
  const currentElement = getItemById(currentFenceGroup.elements, modal.props.id);

  const removeElementHandler = () => {
    dispatch(removeElement(currentIndex));
    dispatch(editNewElementProps({ activeName: currentElement.name }));
    dispatch(closeModal());
  };

  const cancelHandler = () => {
    dispatch(closeModal());
  };

  return (
    <ModalBase title={`${elementNames[currentElement.name]} törlése`}>
      <p className="text-center">Biztosan törlöd ezt az elemet?</p>

      <div className="row">
        <div className="col-6">
          <ButtonBase color="primary" className="w-full" onClick={removeElementHandler}>
            Igen, törlöm
          </ButtonBase>
        </div>

        <div className="col-6">
          <ButtonBase className="w-full" onClick={cancelHandler}>
            Mégsem
          </ButtonBase>
        </div>
      </div>
    </ModalBase>
  );
};

export default ModalRemoveElement;
